export type Field<T> = null | keyof T | ((data: T) => string | number | React.ReactElement | Object);

export default function getField<T>(row: T, field: Field<T>): any {
  if (typeof field === 'function') {
    return field(row);
  } else if (typeof field === 'string') {
    return row[field as keyof T];
  } else {
    return row;
  }
}
